// Router-dom
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// pages
import Country from "./pages/Country";
import Home from "./pages/Home";
import Region from "./pages/Region";
import PageNotFound from "./pages/PageNotFound";

// components
import NavbarFixedTop from "./components/NavbarFixedTop";
import Search from "./pages/Search";
import Currency from "./pages/Currency";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      {/* Navbar Component */}
      <NavbarFixedTop />

      {/* Scroll to top Component
          appeared when page is scrolled to a certain height
      */}
      <ScrollToTop />

      {/* Route classifications */}
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/country/:name" element={<Country />} />
        <Route path="/region" element={<Region />} />
        <Route path="/currency" element={<Currency />} />
        <Route path="/search/:name" element={<Search />} />

        {/* Wildcards for undefined URL */}
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
